import classNames from 'classnames';
import _find from 'lodash/find';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { NERVOUS } from 'constants/emojiReactions';
import { ENTERED_TRIM_MODE } from 'constants/events';
import {
  addTrimRangeCreator,
  enterTrimModeCreator,
  patchTrimVideoCreator,
  redoTrimOperationCreator,
  removeTrimRangeCreator,
  undoTrimOperationCreator,
  updateCurrentTrimRangeCreator,
  updateTrimRangeCreator,
} from 'creators/trimming';
import * as analytics from 'utilities/analytics';

import TrimBar from './trim-bar';
import EmojiBar from '../../video-player/emoji-bar';

import './styles.less';

class ShareVideoControlBar extends Component {
  render() {
    const {
      currentTrimRange,
      duration,
      inTrimMode,
      newTrimChanges,
      redoStack,
      selectedTrimRange,
      theaterMode,
      trimRanges,
      undoStack,
    } = this.props;

    return (
      <div
        className={classNames('share-video-control-bar', {
          'theater-mode': theaterMode,
        })}
      >
        {!inTrimMode && (
          <EmojiBar hideReaction={NERVOUS} sharePageEmojis={true} />
        )}
        {inTrimMode && (
          <TrimBar
            currentTrimRange={currentTrimRange}
            duration={duration}
            newTrimChanges={newTrimChanges}
            redoStack={redoStack}
            selectedTrimRange={selectedTrimRange}
            undoStack={undoStack}
            trimRanges={trimRanges}
            onEndCurrentTrimRange={this.handleEndCurrentTrimRange}
            onCancelCurrentTrimRange={this.props.cancelCurrentTrimRange}
            onDiscardTrimRange={this.props.removeTrimRangeCreator}
            onPublishChanges={this.publishChanges}
            onRedoTrim={this.props.redoTrimOperationCreator}
            onUndoTrim={this.props.undoTrimOperationCreator}
          />
        )}
      </div>
    );
  }

  enterTrimMode = () => {
    const {
      id: videoId,
      processing_information: { trim_ranges: trimRanges = [] },
    } = this.props.video;

    this.props.enterTrimModeCreator(trimRanges);
    this.props.onEnterTrimMode();

    analytics.track(ENTERED_TRIM_MODE, {
      id: videoId,
      has_been_trimmed: trimRanges.length > 0,
    });
  };

  publishChanges = () => {
    const { video } = this.props;

    this.props.patchTrimVideoCreator(video, this.props.onLeaveTrimMode);
  };

  handleEndCurrentTrimRange = trimRange => {
    const { trimRanges } = this.props;

    const foundRange = _find(trimRanges, ({ id }) => id === trimRange.id);

    if (foundRange != null) {
      this.props.updateTrimRangeCreator(trimRange);
    } else {
      this.props.addTrimRangeCreator(trimRange);
    }
  };
}

const mapStateToProps = state => {
  const {
    current_trim_range: currentTrimRange,
    in_trim_mode: inTrimMode,
    new_changes: newTrimChanges,
    redo_stack: redoStack,
    selected_trim_range: selectedTrimRange,
    trim_ranges: trimRanges,
    undo_stack: undoStack,
  } = state.trimming;
  const {
    cta_show: showCta,
    cta_modal_show: showCtaModal,
    cta_enabled: ctaEnabled,
  } = state.share_video;

  const { has_named_video_views: hasNamedVideoViews } = state.user.current;
  const { theater_mode: theaterMode } = state.video_player;

  return {
    currentTrimRange,
    ctaEnabled,
    hasNamedVideoViews,
    inTrimMode,
    newTrimChanges,
    redoStack,
    selectedTrimRange,
    theaterMode,
    trimRanges,
    undoStack,
    showCta,
    showCtaModal,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addTrimRangeCreator: trimRange => dispatch(addTrimRangeCreator(trimRange)),
    cancelCurrentTrimRange: () => dispatch(updateCurrentTrimRangeCreator(null)),
    enterTrimModeCreator: trimRanges =>
      dispatch(enterTrimModeCreator(trimRanges)),
    patchTrimVideoCreator: (video, onFinish) =>
      dispatch(patchTrimVideoCreator(video, onFinish)),
    removeTrimRangeCreator: trimRangeId =>
      dispatch(removeTrimRangeCreator(trimRangeId)),
    redoTrimOperationCreator: () => dispatch(redoTrimOperationCreator()),
    undoTrimOperationCreator: () => dispatch(undoTrimOperationCreator()),
    updateTrimRangeCreator: trimRange =>
      dispatch(updateTrimRangeCreator(trimRange)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShareVideoControlBar);
